export const messages = {
  en: {
    cityArea: {
      detailTitle: 'Area Details',
      areaName: 'Area Name:',
      areaCode: 'Area Code:',
      areaLevel: 'Level:',
      province: 'Province',
      city: 'City',
      district: 'District',
      area: 'Area',
      parentAreaCode: 'Parent Code:',
      parentAreaName: 'Parent Name:',
      createTime: 'Create Time:',
      addArea: 'Add Area',
      editArea: 'Edit Area',
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteArea: 'Confirm to delete this area?',
      cancelDelete: 'Cancel',
      confirmDelete: 'Confirm Delete',
      selectAreaFirst: 'Please select an area first',
      cannotAddChild: 'Cannot add child node',
      areaNameRequired: 'Area name is required',
      areaCodeRequired: 'Area code is required',
      areaNamePlaceholder: 'Required, please enter area name',
      areaCodePlaceholder: 'Required, please enter area code',
      parent: 'Parent'
    }
  },
  zh: {
    cityArea: {
      detailTitle: '地区详情',
      areaName: '地区名称：',
      areaCode: '地区编码：',
      areaLevel: '等级：',
      province: '省级',
      city: '市州',
      district: '区县',
      area: '地区',
      parentAreaCode: '父级编码：',
      parentAreaName: '父级名称：',
      createTime: '创建时间：',
      addArea: '添加区域',
      editArea: '修改区域',
      confirmOperation: '请确认您的操作！',
      confirmDeleteArea: '确定删除该地区？',
      cancelDelete: '点错了',
      confirmDelete: '确认删除',
      selectAreaFirst: '请先选择地区',
      cannotAddChild: '不能添加子节点',
      areaNameRequired: '地区名称不能为空',
      areaCodeRequired: '地区编码不能为空',
      areaNamePlaceholder: '必填，请填写地区名称',
      areaCodePlaceholder: '必填，请填写地区编码',
      parent: '上级'
    }
  }
}